export enum RecordingInfoType {
  Record = 'record',
  Chronology = 'chronology',
}

export interface TabListItem {
  type: RecordingInfoType
  title: string
  isActive: boolean
}
